"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewbuildingPromoCarousel = require("./NewbuildingPromoCarousel");
Object.keys(_NewbuildingPromoCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewbuildingPromoCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewbuildingPromoCarousel[key];
    }
  });
});